import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const LegalLinks = ({ className = "", inverted = false }) => {
  const classes = [
    "legal-links",
    inverted ? "legal-links--inverse" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <nav className={classes} aria-label="Legal and support links">
      <Link className="legal-links__link" to="/privacy-policy">
        Privacy Policy
      </Link>
      <Link className="legal-links__link" to="/terms-of-service">
        Terms of Service
      </Link>
      <a className="legal-links__link" href="mailto:support@teachleague.com">
        support@teachleague.com
      </a>
    </nav>
  );
};

LegalLinks.propTypes = {
  className: PropTypes.string,
  inverted: PropTypes.bool,
};

export default LegalLinks;
